import { FC } from "react";

const ShowSVG: FC = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Show</title>
            <g clipPath="url(#clip0_19_18)">
                <path
                    d="M18.6778 9.73889C16.8056 6.27778 13.5222 4.18333 9.8889 4.18333C6.25557 4.18333 2.96668 6.27778 1.11112 9.73889L0.955566 10L1.10001 10.2667C2.97223 13.7278 6.25557 15.8222 9.8889 15.8222C13.5222 15.8222 16.8111 13.7556 18.6778 10.2667L18.8222 10L18.6778 9.73889ZM9.8889 14.6833C6.76112 14.6833 3.8889 12.9389 2.22223 10C3.8889 7.06111 6.76112 5.31667 9.8889 5.31667C13.0167 5.31667 15.8556 7.06667 17.55 10C15.8556 12.9389 13.0111 14.6833 9.8889 14.6833Z"
                    fill="#D8FFF3"
                    fillOpacity="0.81"
                />
                <path
                    d="M10.05 6.20555C9.29676 6.21105 8.56201 6.43965 7.93859 6.86249C7.31517 7.28532 6.83104 7.88342 6.54734 8.58124C6.26364 9.27907 6.1931 10.0453 6.34463 10.7832C6.49616 11.5211 6.86296 12.1975 7.39871 12.7271C7.93446 13.2566 8.61512 13.6155 9.35472 13.7584C10.0943 13.9014 10.8597 13.8219 11.5542 13.5301C12.2486 13.2383 12.8411 12.7472 13.2566 12.1189C13.6722 11.4906 13.8922 10.7533 13.8889 10C13.8867 9.49857 13.7856 9.00251 13.5914 8.54023C13.3971 8.07795 13.1136 7.65855 12.757 7.30606C12.4003 6.95356 11.9777 6.67491 11.5132 6.48606C11.0486 6.29722 10.5514 6.20189 10.05 6.20555ZM10.05 12.7167C9.51794 12.7112 8.99934 12.5486 8.55936 12.2493C8.11938 11.9501 7.77764 11.5275 7.57705 11.0346C7.37646 10.5418 7.32597 10.0006 7.43192 9.47919C7.53787 8.95774 7.79554 8.47922 8.17256 8.10373C8.54959 7.72824 9.02916 7.47252 9.55104 7.3687C10.0729 7.26488 10.6138 7.31758 11.1059 7.52018C11.5979 7.72278 12.0191 8.06625 12.3166 8.50744C12.614 8.94864 12.7745 9.4679 12.7778 10C12.7793 10.3581 12.7097 10.713 12.573 11.0439C12.4363 11.3749 12.2352 11.6755 11.9815 11.9282C11.7277 12.1809 11.4264 12.3807 11.0948 12.5161C10.7632 12.6514 10.4081 12.7196 10.05 12.7167Z"
                    fill="#D8FFF3"
                    fillOpacity="0.81"
                />
            </g>
            <defs>
                <clipPath id="clip0_19_18">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ShowSVG;
